import { WithSkeleton } from '@capsicum/common';

import { V2FTSupportedDestinationsComponent } from './V2FTSupportedDestinationsComponent';
import { V2FTSupportedDestinationsSkeleton } from './V2FTSupportedDestinationsSkeleton';

export const V2FTSupportedDestinations = WithSkeleton(
	V2FTSupportedDestinationsComponent,
	V2FTSupportedDestinationsSkeleton
);
